import { FIELD } from "./fieldKinds.js";
import { formatDateRange } from "../lib/format.js";
import { COMMON_EVENT_REGISTRATION_FIELDS } from "../features/registration/formConfig.js";
import {
  compose, coverSection, aboutSection, gallerySection, chipsSection,
  speakersSection, agendaSection, rsvpSection, subscribeSection, closingSection,
} from "../features/brochure/sections.js";

// Online webinar / virtual session — no physical venue; a join link instead.
export default {
  id: "webinar",
  category: "professional",
  label: "Webinar / Online session",
  blurb: "Virtual sessions — speakers, agenda, a join link.",
  icon: "💻",
  wizardSteps: [
    {
      id: "basics",
      title: "The essentials",
      fields: [
        { key: "title", label: "Webinar title", kind: FIELD.TEXT, required: true, placeholder: "Scaling React in 2026" },
        { key: "subtitle", label: "Tagline", kind: FIELD.TEXT, placeholder: "Patterns from the field" },
        { key: "heroImage", label: "Hero image", kind: FIELD.HERO_IMAGE, previewPage: "cover" },
      ],
    },
    {
      id: "when-join",
      title: "When & how to join",
      fields: [
        { key: "startDate", label: "Date", kind: FIELD.DATE, required: true },
        { key: "endDate", label: "End date (if multi-day)", kind: FIELD.DATE },
        { key: "registrationUrl", label: "Join / registration link", kind: FIELD.URL, placeholder: "https://zoom.us/...", previewPage: "cover" },
      ],
    },
    {
      id: "details",
      title: "Details, contact & registration",
      fields: [
        { key: "description", label: "About the session", kind: FIELD.TEXTAREA, previewPage: "details" },
        {
          key: "collectEventRegistrations",
          label: "Collect registrations inside einvite",
          kind: FIELD.TOGGLE,
          previewPage: "eventRegistration",
          description: "Adds an in-app registration form. Entries stay visible only to the creator.",
          defaultPatch: { eventRegistrationFields: COMMON_EVENT_REGISTRATION_FIELDS.map((field) => ({ ...field })) },
        },
        {
          key: "eventRegistrationFields",
          label: "Registration form builder",
          kind: FIELD.REGISTRATION_FIELDS,
          previewPage: "eventRegistration",
          showWhen: (details) => !!details.collectEventRegistrations,
        },
        { key: "contacts", label: "Contact persons", kind: FIELD.CONTACTS, previewPage: "closing" },
        {
          key: "collectPreRegistration",
          label: "Subscribe for updates",
          kind: FIELD.TOGGLE,
          previewPage: "subscribe",
          description: "A simple public form for attendees to get updates by mobile or email.",
        },
      ],
    },
    {
      id: "program",
      title: "Program",
      fields: [
        { key: "topics", label: "Topics", kind: FIELD.CHIPS, placeholder: "Add a topic and press Enter", previewPage: "topics" },
        { key: "speakers", label: "Speakers", kind: FIELD.SPEAKERS, previewPage: "speakers" },
        { key: "schedule", label: "Agenda", kind: FIELD.SCHEDULE, itemLabel: "segment", previewPage: "schedule" },
      ],
    },
    {
      id: "custom-slides",
      title: "Custom slides",
      fields: [
        { key: "customSlides", label: "Slides", kind: FIELD.CUSTOM_SLIDES, previewPage: "customSlide" },
      ],
    },
  ],
  planPages(event) {
    const details = event.details || {};
    return compose(
      coverSection(event, { ctaLabel: "Join webinar →" }),
      aboutSection(details),
      gallerySection(details),
      chipsSection(details),
      speakersSection(details),
      agendaSection(details, "schedule", { title: "Agenda" }),
      rsvpSection(event),
      subscribeSection(event),
      closingSection(details, { ctaLabel: "Join webinar →" }),
    );
  },
  deriveOg(details = {}) {
    return {
      title: details.title || "A webinar",
      description: [details.subtitle, formatDateRange(details.startDate, details.endDate), "Online"]
        .filter(Boolean).join(" · "),
    };
  },
};
